import { useCallback } from 'react';

import { client } from '../../../api/rest/client';
import { Actions } from '../../../constants/actionTypes';
import { toastErrorTranslated } from '../../../helpers/toast';
import { useMainDispatch } from '../../useMainDispatch';

export const useRestartPolicyActions = () => {
  const dispatch = useMainDispatch();

  const getRestartPolicyWhitelist = useCallback(async () => {
    try {
      const {
        data: { restartPolicyWhitelist },
      } = await client.bot.getRestartPolicyWhitelist();
      dispatch({
        type: Actions.SET_RESTART_POLICY,
        payload: restartPolicyWhitelist,
      });
      return 'success';
    } catch (error) {
      console.error(error);
      toastErrorTranslated(error);
      return 'error';
    }
  }, [dispatch]);

  const updateRestartPolicyWhitelist = useCallback(
    async (restartPolicyWhitelist: string[]) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await client.bot.updateRestartPolicyWhitelist({
          body: { restartPolicyWhitelist },
        });
        dispatch({
          type: Actions.SET_RESTART_POLICY,
          payload: restartPolicyWhitelist,
        });
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch],
  );

  return { updateRestartPolicyWhitelist, getRestartPolicyWhitelist };
};
